<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml"
          xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <!--  素材管理->视频库-->
  <base-page-component :has-back="false" :has-nav="false" nav-title="视频库">
    <div style="background-color: #F4F8FF;height: calc(100% - 0px)">
      <div class="bg-white m-auto">

        <div class="flex a-center h-60 m-h-25">
          <Button @click="groupManager.show = true" class="m-r-10" type="primary">分类管理</Button>

          <Button @click="toUpload" class="m-r-10" type="primary">上传视频</Button>

          <class-choose-widget :gutter="10" :srcType="10" @dataChange="onClassGroupChange"
                               leftPlaceholder="视频分类"
                               rightPlaceholder="视频分组"
                               style="width: 300px;">

          </class-choose-widget>

          <Button class="m-l-15" type="primary"
                  v-clipboard:copy="objChange.linkurl"
                  v-clipboard:error="onError"
                  v-clipboard:success="copy">复制链接
          </Button>

          <Input class="m-l-15" placeholder="视频名称" style="width: 240px" v-model="title"/>
          <Button @click="onSearchClick" class="m-l-15">搜索</Button>

          <div class="flex flex-1  h-full a-center j-end">
            <Button @click="delMulti" class="m-l-15" type="">批量删除</Button>
          </div>
        </div>

        <div class="">
          <!--          <Table :columns="columns" :data="dataList" :height="tableHeight" ref="table">-->
          <!--            &lt;!&ndash;播放图标&ndash;&gt;-->
          <!--            <template v-slot:play="{row,index}">-->
          <!--              <div class="flex a-center j-center">-->
          <!--                <img @click="play(row)" class="w-40 h-40 p-8" src="../../../assets/common/play-square@2x.png"-->
          <!--                     style="cursor: pointer;">-->
          <!--              </div>-->
          <!--            </template>-->

          <!--            <template v-slot:copy="{row,index}">-->
          <!--              <Tooltip content="复制">-->
          <!--                <div class="flex a-center">-->
          <!--                  <i class=" icon-copy fs-20 m-l-5" style="color: #1472FF;cursor: pointer;"-->
          <!--                     v-clipboard:copy="row.linkurl"-->
          <!--                     v-clipboard:error="onError"-->
          <!--                     v-clipboard:success="copy"/>-->

          <!--                </div>-->
          <!--              </Tooltip>-->
          <!--            </template>-->


          <!--            <template v-slot:link="{row,index}">-->
          <!--              <div class="flex a-center">-->
          <!--                <div class="flex-1 text-left">-->
          <!--                  {{ row.url }}-->
          <!--                </div>-->

          <!--              </div>-->
          <!--            </template>-->

          <!--            <template v-slot:operation="{row,index}">-->
          <!--              <div class="flex a-center j-center">-->
          <!--                <span @click="toEditVideo(row)" class="m-r-20"-->
          <!--                      style="cursor: pointer;color: #3B80FF">编辑</span>-->
          <!--                <span @click="delItem(row,index)"-->
          <!--                      style="cursor: pointer;color: red">删除</span>-->
          <!--              </div>-->
          <!--            </template>-->
          <!--          </Table>-->

          <div
            class="list-container scrollbar  o-y-auto m-l-10"
            :style="{height:tableHeight + 'px'}"
          >
            <!--列表数据-->
            <ratio-div :key="index"
                       v-for="(item,index) in dataList"
                       class=" item  p-h-5"
                      >
              <div class="m-h-5 m-t-5 p-1 shadow"
                   style="position: absolute;width:  calc(100% - 10px);height: calc(100% - 10px)"
                   :class="{'item-selected':item.isSelected}"
                   @click="itemClick(item,index)">
                <!--                  <ratio-div :radio-value="75">-->
                <div class="w-full h-full" style="display: flex;flex-direction: column">
                  <ratio-div class="w-full" :radio-value="75">
                    <img
                      class="w-full h-full absolute"
                      style="object-fit: cover"
                      :src="!item.coverImgUrl?require('../../../assets/common/ic_wutu@2x.png'):$getFomatUrl(item.coverImgUrl,500)"/>
                  </ratio-div>
                  <div class="lin2 m-h-5 m-t-5" style="max-height: 40px">
                    {{ item.title }}
                  </div>
                </div>

                <!--                  </ratio-div>-->

                <!--鼠标悬停编辑-->
                <div class="flex a-center j-center item-editable w-full h-full"
                     style="position: absolute;top: 0;bottom: 0;left: 0;right: 0;background-color: #00000022">
                  <div class="w-30 h-30 b-round flex a-center j-center"
                       style="background-color: #00000099;cursor: pointer;"
                       @click="play(item)">
                    <img src="../../../assets/common/ic-play@2x.png" class="w-15 h-15"/>
                  </div>
                  <div class="w-30 h-30 b-round flex a-center j-center  m-l-15"
                       style="background-color: #00000099;cursor: pointer;"
                       @click.stop="toEditVideo(item)">
                    <img src="../../../assets/common/ic-edit@2x.png" class="w-15 h-15"/>
                  </div>
                  <div class="w-30 h-30 b-round flex a-center j-center m-l-15"
                       style="background-color: #00000099;cursor: pointer;"
                       @click.stop="delItem(item)">
                    <img src="../../../assets/common/ic-delete@2x.png" class="w-15 h-15"/>
                  </div>


<!--                  <div class="w-40 h-40 b-round flex a-center j-center"-->
<!--                       style="background-color: #00000099;cursor: pointer;"-->
<!--                       @click.stop="toEditVideo(item)">-->
<!--                    <img src="../../../assets/common/ic-edit@2x.png" class="w-20 h-20"/>-->
<!--                  </div>-->
<!--                  <div class="w-40 h-40 b-round flex a-center j-center m-l-25"-->
<!--                       style="background-color: #00000099;cursor: pointer;"-->
<!--                       @click.stop="delItem(item)">-->
<!--                    <img src="../../../assets/common/ic-delete@2x.png" class="w-20 h-20"/>-->
<!--                  </div>-->
                </div>
                <!--鼠标悬停三角-->
                <div class="triangle" style="position: absolute;top: 0;right: 0;"
                     v-if="item.isSelected">
                </div>
                <!--鼠标悬停对号-->
                <img class="w-16 h-16" src="../../../assets/common/ic-right@2x.png"
                     style="position: absolute;top: 0;right: 0;"
                     v-if="item.isSelected">

                <!--                <div class="fs-12 m-h-15 m-t-5">{{ item.clazz + ' / ' + item.group }}</div>-->
              </div>
            </ratio-div>
            <!--            <div :key="index" @click="itemClick(item,index)"-->
            <!--                 v-for="(item,index) in dataList"-->
            <!--                 class="m-l-10 m-b-10 item border b-2 h-full"-->
            <!--                 :class="{'item-selected':item.isSelected}">-->

            <!--            </div>-->

          </div>

          <div class="m-l-25" style="padding: 10px 0">
            <Page :current.sync="tablePage.currentPage" :page-size="tablePage.pageSize"
                  :show-total="true"
                  :total="tablePage.total" @on-change="onPageChange"
                  @on-page-size-change="onPageSizeChange"
                  ></Page>
          </div>
        </div>
      </div>
    </div>

    <Modal
      :closable="false"
      class="modal-setting"
      class-name="vertical-center-modal"
      v-model="groupManager.show"
      width="640px"
    >
      <p class="text-center" slot="header">
        <span>{{ groupManager.title }}</span>
      </p>

      <div class="flex a-center j-center" style="width: 600px;height: 360px">
        <class-group-setting-widget2 :objInfo="objInfo"
                                     :srcType="10"
                                     class="w-full h-full">
        </class-group-setting-widget2>
      </div>

    </Modal>

    <Modal
      @on-visible-change="onVideoPrewModalClose"
      class-name="vertical-center-modal"
      footer-hide
      v-model="showVideoPrew"
      width="650">
      <video-prew :videoinfo="videoprewinfo" ref="prewplayer"/>
    </Modal>

    <upload-edit-video-widget
      ref="uploadEditVideoWidget"
      :on-ok="getVideoListData"
    />
  </base-page-component>

</template>

<script>
import BasePageComponent from '@/components/common/BasePageComponent'
import ClassGroupSettingWidget2 from '@/components/common/ClassGroupSettingWidget2'
import ClassChooseWidget from '../../../components/common/ClassChooseWidget'
import {mapActions} from 'vuex'
import mixin from '../../../config/mixinfile'
import VideoPrew from '@/components/common/VideoPrew'
import RatioDiv from '@/components/common/RatioDiv'
import UploadEditVideoWidget from '@/views/material/video/component/UploadEditVideoWidget'

export default {
  name: 'VideoRepository',
  mixins: [mixin.mixin],
  components: {
    UploadEditVideoWidget,
    RatioDiv,
    VideoPrew,
    ClassChooseWidget,
    ClassGroupSettingWidget2,
    BasePageComponent
  },
  watch: {},
  data () {
    return {
      objChange: {                               //分类分组帅选
        classId: 0,
        groupId: 0,
        linkurl: 'https://goodsmanual.laodao.co/video/materialVideoCategory.html?contentType=51&id=0'
      },
      tableHeight: 620,
      tablePage: {                               //表格分页
        total: 0,
        currentPage: 1,
        pageSize: 35,
      },
      objInfo: {
        classId: 0,
        className: '',
        groupId: 0,
        groupName: '',
        init: false
      },
      title: '',
      groupManager: {
        title: '分类管理',
        show: false,
      },

      columns: [
        {
          type: 'selection',
          width: 55,
          align: 'center'
        }, {
          title: '分类',
          key: 'categoryName',
          width: 110,
          align: 'center'
        }, {
          title: '分组',
          key: 'groupName',
          width: 110,
          align: 'center'
        }, {
          title: '视频标题',
          key: 'title',
          minWidth: 350,
          tooltip: true,
        }, {
          title: '视频时长',
          key: 'videoLength',
          width: 160,
          align: 'center'
        }, {
          title: '播放',
          slot: 'play',
          align: 'center',
          width: 96,
        }, {
          //   title: '视频链接',
          //   key: 'linkurl',
          //   minWidth: 400,
          //   align: 'center',
          //   tooltip: true,
          // }, {
          //   title: '复制',
          //   slot: 'copy',
          //   width: 100,
          //   align: 'left'
          // }, {
          title: '操作',
          slot: 'operation',
          width: 150,
          align: 'center',
        }],
      dataList: [],
      //视频预览
      showVideoPrew: false,
      videoprewinfo: {       //预览参数
        videoAliVid: '',
        videoUrl: '',
        coverUrl: '',
        videoTitle: ''
      },

      // 选中项
      maps: new Map(),
    }
  },
  mounted () {
    this.init()
  },
  activated () {
    this.setTableHeight()
    this.getVideoListData()
  },
  methods: {
    init () {
      this.setTableHeight()
      this.getVideoListData()
    },
    setTableHeight(){
      this.tableHeight = window.innerHeight - 250
      window.onresize = () => {
        this.tableHeight = window.innerHeight - 250
      }
    },
    getVideoListData () {
      let params = {
        pageSize: this.tablePage.pageSize,
        pageNum: this.tablePage.currentPage
      }
      if (this.title) {
        params.title = this.title
      }
      if (this.objChange && this.objChange.classId) {
        params.categoryId = this.objChange.classId
      }
      if (this.objChange && this.objChange.groupId) {
        params.groupId = this.objChange.groupId
      }
      this.getVideoList(params).then(res => {
        if (res.code == 0) {
          this.dataList = res.data.list.map(child => {
            child.createTime = child.createTime ? new Date(child.createTime).format('yyyy-MM-dd') : ''
            child.videoLength = this.formatSeconds(child.videoLength)
            child.linkurl = child.jumpLink ? child.jumpLink.link || '' : ''
            if (this.maps.has(child.imgId))
              this.$set(child, 'isSelected', true)
            else
              this.$set(child, 'isSelected', false)
            return child
          })
          this.tablePage.total = res.data.total
        }
      })
    },
    formatSeconds (value) {
      var secondTime = parseInt(value)// 秒
      var minuteTime = 0// 分
      var hourTime = 0// 小时
      if (secondTime > 60) {//如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(secondTime / 60)
        //获取秒数，秒数取佘，得到整数秒数
        secondTime = parseInt(secondTime % 60)
        //如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
          //获取小时，获取分钟除以60，得到整数小时
          hourTime = parseInt(minuteTime / 60)
          //获取小时后取佘的分，获取分钟除以60取佘的分
          minuteTime = parseInt(minuteTime % 60)
        }
      }
      var result = '' + parseInt(secondTime) + '秒'

      if (minuteTime > 0) {
        result = '' + parseInt(minuteTime) + '分' + result
      }
      if (hourTime > 0) {
        result = '' + parseInt(hourTime) + '小时' + result
      }
      return result
    },
    play (item) {
      if (item.sourceUrl || item.videoAliVid) {
        this.videoprewinfo = {
          videoUrl: item.sourceUrl || '',
          videoAliVid: item.videoAliVid || '',
          coverUrl: item.coverImgUrl,
          videoTitle: item.title
        }
        this.showVideoPrew = true
      }
    },
    toUpload () {
      // this.$router.push('/videoUpload')
      this.$refs.uploadEditVideoWidget.showUpload()
    },
    delItem (row, index) {
      const content = '<p>确定要删除 ' + row.title + ' 吗?</p>'
      this.$Modal.confirm({
        title: '提示',
        content: content,
        onOk: () => {
          let params = {
            idList: row.videoId
          }
          this.delVideo(params).then(res => {
            if (res.code === 0) {
              this.maps.delete(row.videoId)
              this.getVideoListData()
            }
            this.$Message.success(res.msg)
          })
        },
        onCancel: () => {
        }
      })
    },
    copy (e) {
      this.$Message.info('复制成功')
    },
    onError (e) {
      this.$Message.info('复制失败')
    },
    itemClick (item, index) {
      item.isSelected = !item.isSelected
      if (item.isSelected)
        this.maps.set(item.videoId, item)
      else
        this.maps.delete(item.videoId)
    },
    //无请求,模拟删除
    delMulti () {

      // let selections = this.$refs.table.getSelection()
      if (this.maps.size === 0) {
        this.$Message.info('没有选中视频')
        return
      }
      const content = '<p>确定要删除吗?</p>'
      this.$Modal.confirm({
        title: '提示',
        content: content,
        onOk: () => {
          // let selections = this.$refs.table.getSelection()
          let ids = ''
          this.maps.forEach((value, key) => {
            ids+=key + ','
          })
          ids = ids.substring(0,ids.length-1)
          let params = {
            idList: ids
          }
          // let ids = selections.map(res => {
          //   return res.videoId
          // }).join(',')
          // let params = {
          //   idList: ids
          // }
          this.delVideo(params).then(res => {
            if (res.code === 0) {
              this.maps.clear()
              this.getVideoListData()
            }
            if (res.msg) {
              this.$Message.success(res.msg)
            }
          })

        },
        onCancel: () => {
        }
      })
    },
    toEditVideo (row) {
      // this.$router.push({
      //   path: '/editVideo',
      //   query: {
      //     videoId: row.videoId
      //   }
      // })
      this.$refs.uploadEditVideoWidget.showEdit(row.videoId)
    },
    /**
     * 分类分组筛选
     * @param e
     */
    onClassGroupChange (e) {
      this.objChange = e
      if (!this.objChange.linkurl) {
        this.objChange.linkurl = 'https://goodsmanual.laodao.co/video/materialVideoCategory.html?contentType=51&id=0'
      }
      this.tablePage.currentPage = 1
      this.getVideoListData()
    },
    /**
     * 分页请求
     * @param e
     */
    onPageChange (e) {
      this.tablePage.currentPage = e
      this.dataList.splice(0, this.dataList.length - 1)
      this.getVideoListData()
    },
    /**
     * 换页条数请求处理
     * @param e
     */
    onPageSizeChange (e) {
      this.tablePage.pageSize = e
      if (this.tablePage.currentPage === 1) {
        this.getVideoListData()
      }
    },
    onVideoPrewModalClose (status) {
      if (!status) {
        this.videoprewinfo = {
          videoUrl: '',
          videoAliVid: '',
          coverUrl: '',
          videoTitle: ''
        }
      }
    },
    /**
     * 输入搜索筛选
     */
    onSearchClick () {
      this.tablePage.currentPage = 1
      this.getVideoListData()
    },
    ...mapActions([
      'getVideoList',
      'delVideo',
    ])
  }
}
</script>

<style lang="scss" scoped>
.modal-setting ::v-deep {

  .ivu-modal-body {
    padding: 0;
    display: flex;
    justify-content: center;
    align-content: center;
  }

  //标题下横线
  .ivu-modal-header {
    border-bottom: none;
  }

  //确认取消按钮上面红线
  .ivu-modal-footer {
    border-top: none;
  }
}

</style>

<style scoped>
.liHover:hover {
  background: #EDF3FF;
}

.liHover:hover .selectHover {
  display: block;

}


.list-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
  /*overflow: auto;*/
}

.item {
  width: 14.2%;
  /*height: 220px;*/
  flex-direction: row;
  margin-bottom: 10px;
}

.shadow {
  box-shadow: 0 2px 7px rgb(0 0 0 / 15%);
}

.item-selected {
  border: 1px solid #0EA4FB;
}

.item-editable {
  display: none;
}

.item:hover .item-editable {
  display: flex;
}

.lin2 {
  /*font-size: 14px;*/
  height: 28px;
  line-height: 14px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
  -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
  -webkit-line-clamp: 2; /** 显示的行数 **/
  overflow: hidden; /** 隐藏超出的内容 **/
}

.triangle {
  width: 0;
  height: 0;
  border-color: transparent #0F8CFB;
  border-width: 0 25px 25px 0;
  border-style: solid;
}
</style>
